module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Medium.b50127e4.woff";